<template>
  <v-app class="app-background ma-3">
    <el-row type="flex" justify="center" class="my-4">
      <h1>FAQ</h1>
    </el-row>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="Pertanyaan 1" name="1">
        <div>Consistent with real life: in line with the process and logic of real life, and comply with languages and habits that the users are used to;</div>
        <div>Consistent within interface: all elements should be consistent, such as: design style, icons and texts, position of elements, etc.</div>
      </el-collapse-item>
      <el-collapse-item title="Pertanyaan 2" name="2">
        <div>Operation feedback: enable the users to clearly perceive their operations by style updates and interactive effects;</div>
        <div>Visual feedback: reflect current state by updating or rearranging elements of the page.</div>
      </el-collapse-item>
      <el-collapse-item title="Pertanyaan 3" name="3">
        <div>Simplify the process: keep operating process simple and intuitive;</div>
        <div>Definite and clear: enunciate your intentions clearly so that the users can quickly understand and make decisions;</div>
        <div>Easy to identify: the interface should be straightforward, which helps the users to identify and frees them from memorizing and recalling.</div>
      </el-collapse-item>
      <el-collapse-item title="Pertanyaan 4" name="4">
        <div>Decision making: giving advices about operations is acceptable, but do not make decisions for the users;</div>
        <div>Controlled consequences: users should be granted the freedom to operate, including canceling, aborting or terminating current operation.</div>
      </el-collapse-item>
    </el-collapse>

    <div class="bg-ellips"></div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ['1']
    };
  },
  methods: {},
  computed: {}
};
</script>

<style>
.app-background {
  background: white !important;
}
.el-collapse-item__header.is-active {
  color: #1989fa;
}
</style>
